module.exports = __webpack_public_path__ + "static/img/page_PLAY01.7145fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series6-moocs/course3/page_PLAY01.png
// module id = D6Wa
// module chunks = 0